<template>
    <v-popup :modelValue="modelValue" title="Приглашения" @update:modelValue="close">
        <div class="invitation-popup-content">
            <p class="invitation-popup__subtitle">У вас есть приглашения в компании</p>
            <div class="invitation-list">
                <div
                    class="invitation-item"
                    v-for="invitation in userStore.invitations"
                    :key="invitation.id"
                >
                    <div class="invitation-item__info">
                        <h3>{{ invitation.companyName }}</h3>
                        <span>{{ role.formatRoleName(invitation.roleName) }}</span>
                    </div>
                    <div class="invitation-item__actions">
                        <default-button
                            text="Отклонить"
                            isSecondary
                            @click="reject(invitation.memberId)"
                        />
                        <default-button
                            text="Принять"
                            @click="accept(invitation.memberId)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <default-button text="Закрыть" isSecondary @click="close" />
        </template>
    </v-popup>
</template>

<script>
import { useUserStore } from '@/store/UserStore.js'
import { useInvitationStore } from '@/store/InvitationStore.js'
import role from '@/utils/role'

export default {
    name: 'InvitationPopup',
    props: {
        modelValue: {
            type: Boolean,
            required: true
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            userStore: useUserStore(),
            invitationStore: useInvitationStore(),
            role
        }
    },
    methods: {
        close() {
            this.invitationStore.close()
        },
        async accept(memberId) {
            await this.userStore.respondToInvitation(memberId, true)
            if (!this.userStore.invitations || this.userStore.invitations.length === 0) {
                this.invitationStore.close()
            }
        },
        async reject(memberId) {
            await this.userStore.respondToInvitation(memberId, false)
            if (!this.userStore.invitations || this.userStore.invitations.length === 0) {
                this.invitationStore.close()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.invitation-popup-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.invitation-popup__subtitle {
    margin: 0;
    color: var(--color-text-light);
    font-size: 14px;
}

.invitation-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.invitation-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 14px 16px;
    border: 1px solid var(--color-border);
    border-radius: 12px;
    background-color: var(--color-bg-dark);

    &__info {
        display: flex;
        flex-direction: column;
        gap: 4px;

        h3 {
            margin: 0;
            font-size: 15px;
            font-weight: 600;
            color: var(--color-text);
        }

        span {
            font-size: 13px;
            color: var(--color-text-light);
        }
    }

    &__actions {
        display: flex;
        gap: 10px;
        flex-shrink: 0;
    }

    @media (max-width: 540px) {
        flex-direction: column;
        align-items: stretch;

        &__actions {
            justify-content: flex-end;
        }
    }
}
</style>
